export const SUBMIT_ANSWER = 'SUBMIT_ANSWER';
export const SECURITY_QUESTION = 'SECURITY_QUESTION';


